// extracted by mini-css-extract-plugin
export default {"wrapper":"TabbedMultipleSelectFilter_wrapper__mNusy","scroll-area":"TabbedMultipleSelectFilter_scroll-area__LWTij","option":"TabbedMultipleSelectFilter_option__OVv7V"};